import { useApiGetQuery, useApiMutation } from 'utils/queryClient'

export const currentAccountQueryKey = ['currentAccount']

const useCurrentAccount = (options = {}) =>
  useApiGetQuery({
    endpoint: '/account',
    queryKey: currentAccountQueryKey,
    options: { staleTime: 60_000, ...options },
  })

export const useUpdateCurrentAccount = (options = {}) =>
  useApiMutation('/account', 'patch', options)

export default useCurrentAccount
